// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
    width: 16rem;
    background-color: #3A4856;
    color: #fff;
    height: calc(100% - 4rem);
    flex-direction: column;
    display:flex;
    position: absolute;
    left: -16rem;
    z-index: 1001;
    transition: left 0.5s;
    -webkit-transition: left 0.5s;
}

nav.active {
    left: 0;
}

nav ul {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;
}

nav ul li a.btn.btn-link {
    padding: .5rem 1.5rem .5rem 1rem;
    display: block;
    color:#FFF
}

nav ul li a.btn.btn-link:hover {
    color: #F1FAFF;
    background-color: #162029;
}

nav ul li.navigation-header {
    font-family: "Muli", Georgia, "Times New Roman", Times, serif;
    font-weight: 400;
    line-height: 1.2;
    color: #F1FAFF;
    padding: 20px 20px 8px 20px;
    font-weight: 600;
    text-transform: uppercase;
}

nav .nav-footer .version {
    text-align: center;
    padding:.5rem;
    font-size: .8rem;
    color: #F1FAFF;
}

.nav-background {
    display:none;
    background: black;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    z-index: 1000;
    transition: opacity 0.5s;
    -webkit-transition: opacity 0.5s;
}

.nav-background.active {
    display: block;
    opacity: 0.7;
}


@media (min-width: 1600px) {
    nav {
        left: 0;
    }

    .nav-background.active {
        display: none !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/nav.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,OAAO;AACX;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;IAC7D,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;;AAGA;IACI;QACI,OAAO;IACX;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["nav {\r\n    width: 16rem;\r\n    background-color: #3A4856;\r\n    color: #fff;\r\n    height: calc(100% - 4rem);\r\n    flex-direction: column;\r\n    display:flex;\r\n    position: absolute;\r\n    left: -16rem;\r\n    z-index: 1001;\r\n    transition: left 0.5s;\r\n    -webkit-transition: left 0.5s;\r\n}\r\n\r\nnav.active {\r\n    left: 0;\r\n}\r\n\r\nnav ul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    flex: 1;\r\n}\r\n\r\nnav ul li a.btn.btn-link {\r\n    padding: .5rem 1.5rem .5rem 1rem;\r\n    display: block;\r\n    color:#FFF\r\n}\r\n\r\nnav ul li a.btn.btn-link:hover {\r\n    color: #F1FAFF;\r\n    background-color: #162029;\r\n}\r\n\r\nnav ul li.navigation-header {\r\n    font-family: \"Muli\", Georgia, \"Times New Roman\", Times, serif;\r\n    font-weight: 400;\r\n    line-height: 1.2;\r\n    color: #F1FAFF;\r\n    padding: 20px 20px 8px 20px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n}\r\n\r\nnav .nav-footer .version {\r\n    text-align: center;\r\n    padding:.5rem;\r\n    font-size: .8rem;\r\n    color: #F1FAFF;\r\n}\r\n\r\n.nav-background {\r\n    display:none;\r\n    background: black;\r\n    opacity: 0;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    position: absolute;\r\n    z-index: 1000;\r\n    transition: opacity 0.5s;\r\n    -webkit-transition: opacity 0.5s;\r\n}\r\n\r\n.nav-background.active {\r\n    display: block;\r\n    opacity: 0.7;\r\n}\r\n\r\n\r\n@media (min-width: 1600px) {\r\n    nav {\r\n        left: 0;\r\n    }\r\n\r\n    .nav-background.active {\r\n        display: none !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
